exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report[data-v-357037ba]{margin-top:30px}.center[data-v-357037ba]{text-align:center}.btn-export[data-v-357037ba]{text-align:right;margin-bottom:.25rem}.break-word[data-v-357037ba]{word-break:break-all}.colour-pdf[data-v-357037ba]{color:red}.colour-excel[data-v-357037ba]{color:green}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-357037ba","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reportes/materiales/ConsultaMaterialesDigitalizacion.vue
// module id = 260
// module chunks = 58